import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AjaxService } from 'src/app/service/ajax.service';
import { UtilService } from 'src/app/service/util.service';
import { UserService } from 'src/app/services/user.service';
import { API } from 'src/environments/environment';

interface Opcao {
  id: number;
  descricao: string;
}

@Component({
  selector: 'app-cadastrar-fornecedor',
  templateUrl: './cadastrar-fornecedor.component.html',
  styleUrls: ['./cadastrar-fornecedor.component.scss']
})
export class CadastrarFornecedorComponent implements OnInit {
  cnpjMask = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
  cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/ ,'-', /\d/, /\d/];
  cepMask = [/\d/, /\d/, ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/ ];
  telefoneMask = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  id = 0;
  codigo: number | null = null;
  nome = '';
  razaoSocial = '';
  cnpj = '';
  cpf = '';
  cep = '';
  idTipoLogradouro: number | null = null;
  logradouro = '';
  numero: number | null = null;
  bairro = '';
  complemento = '';
  cidId = '';
  inscricaoEstadual = '';
  inscricaoMunicipal = '';
  ativo = true;
  telefone1 = '';
  telefone2 = '';
  email1 = '';
  email2 = '';
  email3 = '';
  observacao = '';
  idFinStatusFornecedor = 0;
  idPlanoContas = 0;

  tiposLogradouro: Opcao[] = [];
  statusFornecedor: Opcao[] = [];
  planosContas: Opcao[] = [];

  constructor(
    private ajaxService: AjaxService,
    private util: UtilService,
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.carregarOpcoes();
    this.route.queryParamMap.subscribe((params) => {
      this.id = Number(params.get('id') || 0);
      if (this.id > 0) {
        this.carregarFornecedor();
      } else {
        this.novo();
      }
    });
  }

  novo(): void {
    this.id = 0;
    this.nome = '';
    this.razaoSocial = '';
    this.cnpj = '';
    this.cpf = '';
    this.cep = '';
    this.idTipoLogradouro = null;
    this.logradouro = '';
    this.numero = null;
    this.bairro = '';
    this.complemento = '';
    this.cidId = '';
    this.inscricaoEstadual = '';
    this.inscricaoMunicipal = '';
    this.ativo = true;
    this.telefone1 = '';
    this.telefone2 = '';
    this.email1 = '';
    this.email2 = '';
    this.email3 = '';
    this.observacao = '';
    this.idFinStatusFornecedor = 0;
    this.idPlanoContas = 0;
  }

  carregarOpcoes(): void {
    this.ajaxService.get(`${API}financeiro/FinFornecedor/ConsultarOpcoes`).subscribe({
      next: (response) => {
        const data = this.util.converterParaLowercase(response?.data ?? response ?? {});
        this.tiposLogradouro = this.normalizarLista(data.tiposlogradouro).map((x: any) => ({
          id: Number(x.id || 0),
          descricao: String(x.descricao || '')
        })).filter((x: Opcao) => x.id > 0);

        this.statusFornecedor = this.normalizarLista(data.statusfornecedor).map((x: any) => ({
          id: Number(x.id || 0),
          descricao: String(x.descricao || '')
        })).filter((x: Opcao) => x.id > 0);

        this.planosContas = this.normalizarLista(data.planoscontas).map((x: any) => ({
          id: Number(x.id || 0),
          descricao: String(x.descricao || '')
        })).filter((x: Opcao) => x.id > 0);

        if (this.id === 0 && !this.codigo) {
          this.codigo = data.proximocodigo ? Number(data.proximocodigo) : null;
        }
      }
    });
  }

  carregarFornecedor(): void {
    if (this.id <= 0) return;
    this.util.showLoading();
    this.ajaxService.get(`${API}financeiro/FinFornecedor/Obter?id=${this.id}`).subscribe({
      next: (response) => {
        this.util.closeLoading();
        const data = this.util.converterParaLowercase(response?.data ?? response ?? {});
        this.codigo = data.codigo ? Number(data.codigo) : null;
        this.nome = String(data.nome || '');
        this.razaoSocial = String(data.razaosocial || '');
        this.cnpj = String(data.cnpj || '');
        this.cpf = String(data.cpf || '');
        this.cep = String(data.cep || '');
        this.idTipoLogradouro = data.idtipologradouro ? Number(data.idtipologradouro) : null;
        this.logradouro = String(data.logradouro || '');
        this.numero = data.numero ? Number(data.numero) : null;
        this.bairro = String(data.bairro || '');
        this.complemento = String(data.complemento || '');
        this.cidId = String(data.cidid || '');
        this.inscricaoEstadual = String(data.inscricaoestadual || '');
        this.inscricaoMunicipal = String(data.inscricaomunicipal || '');
        this.ativo = Boolean(data.ativo);
        this.telefone1 = String(data.telefone1 || '');
        this.telefone2 = String(data.telefone2 || '');
        this.email1 = String(data.email1 || '');
        this.email2 = String(data.email2 || '');
        this.email3 = String(data.email3 || '');
        this.observacao = String(data.observacao || '');
        this.idFinStatusFornecedor = Number(data.idfinstatusfornecedor || 0);
        this.idPlanoContas = Number(data.idplanocontas || 0);
      },
      error: () => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Não foi possível carregar o fornecedor.');
      }
    });
  }

  salvar(): void {
    if (!this.nome?.trim()) {
      this.util.toasterShowError('Atenção', 'Informe o nome do fornecedor.');
      return;
    }
    if (!this.idFinStatusFornecedor || this.idFinStatusFornecedor <= 0) {
      this.util.toasterShowError('Atenção', 'Selecione o status do fornecedor.');
      return;
    }
    if (!this.idPlanoContas || this.idPlanoContas <= 0) {
      this.util.toasterShowError('Atenção', 'Selecione o plano de contas.');
      return;
    }

    const payload = {
      id: this.id || 0,
      idUsuario: this.getIdUsuarioLogado(),
      codigo: this.codigo,
      nome: this.nome,
      razaoSocial: this.razaoSocial,
      cnpj: this.cnpj,
      cpf: this.cpf,
      cep: this.cep,
      idTipoLogradouro: this.idTipoLogradouro,
      logradouro: this.logradouro,
      numero: this.numero,
      bairro: this.bairro,
      complemento: this.complemento,
      cidId: this.cidId,
      inscricaoEstadual: this.inscricaoEstadual,
      inscricaoMunicipal: this.inscricaoMunicipal,
      ativo: this.ativo,
      telefone1: this.telefone1,
      telefone2: this.telefone2,
      email1: this.email1,
      email2: this.email2,
      email3: this.email3,
      observacao: this.observacao,
      idFinStatusFornecedor: this.idFinStatusFornecedor,
      idPlanoContas: this.idPlanoContas
    };

    this.util.showLoading();
    this.ajaxService.post(`${API}financeiro/FinFornecedor/Salvar`, payload).subscribe({
      next: (response) => {
        this.util.closeLoading();
        if (response?.hasErrors) {
          this.util.toasterShowError('Erro', response?.message || 'Não foi possível salvar.');
          return;
        }
        this.util.toasterShowSuccess('Sucesso', this.id > 0 ? 'Fornecedor atualizado com sucesso!' : 'Fornecedor cadastrado com sucesso!');
        this.router.navigate(['/consultar-fornecedor']);
      },
      error: () => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Erro ao salvar fornecedor.');
      }
    });
  }

  voltar(): void {
    this.router.navigate(['/consultar-fornecedor']);
  }

  private normalizarLista(data: any): any[] {
    if (!data) return [];
    if (Array.isArray(data)) return data;
    if (typeof data === 'object') {
      if (Object.prototype.hasOwnProperty.call(data, 'id') || Object.prototype.hasOwnProperty.call(data, 'descricao')) return [data];
      return Object.values(data).filter((x: any) => x && typeof x === 'object');
    }
    return [];
  }

  private getIdUsuarioLogado(): number | null {
    const userData = this.userService.getUserData();
    if (!userData) return null;

    const userId =
      Number(userData.User?.Id) ||
      Number((userData as any)?.['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/sid']) ||
      0;

    return userId > 0 ? userId : null;
  }
}
